/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockStocktakePriceboxCtrl
 */
angular.module('mercury.modules.stock.stocktake')
.controller('StockStocktakePriceboxCtrl', ["$scope", "$stateParams", "StockItems", "StockPurchaseOrders", "Invoices", "StockCost", "$q", function($scope, $stateParams, StockItems, StockPurchaseOrders, Invoices, StockCost, $q) {
  $scope.line = {
    quantity: $stateParams.quantity,
    unitName: $stateParams.unitName,
    unitRatio: $stateParams.unitRatio
  };

  $scope.loading = $q.all({
    item: StockItems.getStockApi($stateParams.itemId).$promise,
    cost: StockCost.get([`${$stateParams.itemId},${$stateParams.dateFor || moment().format()}`])
  }) 

  $scope.loading.then(function(result) {
    var item = result.item
    var itemStockCost = result.cost.itemCosts[item.id][0];

    item.unitCost = itemStockCost.cost
    item.currentPriceDocumentId = itemStockCost.documentId
    item.currentPriceDocumentType = itemStockCost.documentType
    
    $scope.item = item;
    
    if ($stateParams.dateFor) {
      $scope.title = 'Purchase Cost for ' + item.name + ' at ' + moment($stateParams.dateFor).format('D MMM, h:mma');
    } else {
      $scope.title = 'Current Price for ' + item.name;
    }

    if (item.currentPriceDocumentId) {
      if (item.currentPriceDocumentType == 'PurchaseOrder'){
        $scope.loading = StockPurchaseOrders.getStockApi(item.currentPriceDocumentId).$promise;
      } else {
        $scope.loading = Invoices.getInvoice(item.currentPriceDocumentId).$promise;
      }
      
      $scope.loading.then(function(document) {
        var lineWithItem = document.lines.filter(line => line.itemId === $stateParams.itemId || line.linkedItemId == $stateParams.itemId)

        $scope.source = {
          document: document,
          quantity: lineWithItem[0].quantityReceived,
          unitName: document.type == 'Invoice' ? lineWithItem[0].unit : lineWithItem[0].unitName,
          unitCost: lineWithItem[0].unitCost,
          unitRatio: document.type == 'Invoice' ? lineWithItem[0].linkedUnitRatio : lineWithItem[0].unitRatio
        };
      });
    } else {
      $scope.source = {
        quantity: 1,
        unitName: item.orderingUnitName,
        unitRatio: item.orderingUnitRatio,
        unitCost: item.currentPrice
      };
    }
  });

  $scope.calculateBaseUnitCost = (unitCost, unitRatio) => {
    return unitCost / unitRatio
  }
}]);
